if (document.querySelector('.form-wkps')) {
    const formularios = document.querySelectorAll('.form-wkps');

    formularios.forEach(formulario => {
        let elementosBR = formulario.getElementsByTagName('br');

        for (var i = elementosBR.length - 1; i >= 0; i--) {
            elementosBR[i].parentNode.removeChild(elementosBR[i]);
        }
    });

}